import unauthorizedAttemptsService from '@/api/unauthorized-attempts-service';

export const getDefaultUnauthorizedAttemptsFilterParams = () => ({});

const state = {
  unauthorizedAttempts: null,
  unauthorizedAttemptsPagination: {},
  unauthorizedAttemptsFilterParams: getDefaultUnauthorizedAttemptsFilterParams(),
  // UnauthorizedAttemptValidationErrors: {},
  // newUnauthorizedAttempt: {},
};

const mutations = {
  SET_UNAUTHORIZED_ATTEMPTS(state, { data, meta }) {
    state.unauthorizedAttempts = data;
    state.unauthorizedAttemptsPagination = {
      current_page: meta.current_page,
      per_page: meta.per_page,
      total: meta.total,
    };
  },

  SET_FILTER_PARAMS(state, params) {
    state.unauthorizedAttemptsFilterParams = params;
  },

  // SET_UNAUTHORIZED_ATTEMPT_VALIDATION_ERRORS(state, validationErrors) {
  //   state.UnauthorizedAttemptValidationErrors = validationErrors;
  // },

  // RESET_UNAUTHORIZED_ATTEMPTS_VALIDATION_ERRORS(state) {
  //   state.UnauthorizedAttemptValidationErrors = {};
  // },

  // CLEAR_VALIDATION_ERRORS(state, field) {
  //   delete state.UnauthorizedAttemptValidationErrors[field];
  // },
};

const actions = {
  fetchUnauthorizedAttempts({ commit }, params) {
    commit('SET_FILTER_PARAMS', params);
    return unauthorizedAttemptsService.getPage(params).then((res) => {
      commit('SET_UNAUTHORIZED_ATTEMPTS', res.data);
      return res.data;
    });
  },

  // clearUnauthorizedAttemptsValidationErrors({ commit }, field) {
  //   commit('CLEAR_VALIDATION_ERRORS', field);
  // },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
